import { Tooltip } from "antd";

import styles from "./RVEntityTag.module.scss";

/**
 * Represents a tag entity with an id and name
 */
export type Tag = {
    /** Unique identifier for the tag */
    id: string;
    /** Display name of the tag */
    name: string;
};

/**
 * Props for the RVEntityTag component
 */
type RVEntityTagProps = {
    /** The tag object to display */
    tag: Tag;
};

/**
 * A component that displays a single tag with a tooltip showing the full tag name.
 * Used to render individual tags for entities like Campaigns and Journeys.
 *
 * @param tag - The tag object containing id and name
 * @returns A styled tag component with tooltip functionality
 */
export function RVEntityTag({ tag }: RVEntityTagProps): JSX.Element {
    return (
        <Tooltip title={tag.name} mouseEnterDelay={1}>
            <span className={styles.tagLabelContainer}>{tag.name}</span>
        </Tooltip>
    );
}
